import { View } from "react-native"
import BFText from "@/components/standard/BFText"

export const AddressDisplay = ({
  street,
  cityStateZip,
  theme = "light",
}: {
  street: string
  cityStateZip: string
  theme?: "light" | "dark"
}) => {
  return (
    <View>
      <BFText
        className={`text-center mt-9 ${theme === "light" ? "text-white" : "text-darkest"} font-figtree-extrabold`}
      >
        {street}
      </BFText>
      <BFText
        className={`text-center mx-8 ${theme === "light" ? " text-white" : " text-darkest"} font-spacegrotesk`}
      >
        {cityStateZip}
      </BFText>
      <View
        className={`w-full h-px ${theme === "light" ? " bg-white" : " bg-gray-300"}  mt-2 mb-10`}
      />
    </View>
  )
}
